export enum AIFileType {
	PDF = 'pdf',
	DOCX = 'docx',
	TXT = 'txt',
	OTHER = 'other',
	JSON ='json',
	IMAGE ='image',
	VIDEO ='video',
	AUDIO='audio'
}